import { render, staticRenderFns } from "./bulletinCommit.vue?vue&type=template&id=c690738a&"
import script from "./bulletinCommit.vue?vue&type=script&lang=js&"
export * from "./bulletinCommit.vue?vue&type=script&lang=js&"
import style0 from "./bulletinCommit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports